import { getElements } from 'js-utils/src/selector';
import Cookies from 'js-cookie';

import init from './init';

init(() => {
  const toggleCookie = getElements('.toggle--cookie');
  if(!toggleCookie.length) return;

  toggleCookie.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const container = trigger.closest('.togglable');
      const cookieVal = Cookies.get(container.getAttribute('data-category-name'));

      if(cookieVal == 'true') {
        Cookies.remove(container.getAttribute('data-category-name'));
      }
      else {
        Cookies.set(container.getAttribute('data-category-name'), 'true', { expires: 365 });
      }
    });
  });
});
